import { IMarketYoyGrowthPlanningApi } from '../api/types'
import { IMarketYoyGrowthPlanning } from '../model/types'

export const mapMarketYoyGrowthPlanningFromApi = (
  data: IMarketYoyGrowthPlanningApi
): IMarketYoyGrowthPlanning => ({
  entryId: data.EntryId,
  uid: data.UID,
  created: data.Created,
  createdBy: data.CreatedBy,
  modified: data.Modified,
  modifiedBy: data.ModifiedBy,
  fYear: data.FYear,
  status: data.Status,
  isLocked: Boolean(data.IsLocked),
})
